import { render, staticRenderFns } from "./FieldDateHeading.vue?vue&type=template&id=7dc8e1e6&scoped=true"
import script from "./FieldDateHeading.vue?vue&type=script&lang=js"
export * from "./FieldDateHeading.vue?vue&type=script&lang=js"
import style0 from "./FieldDateHeading.vue?vue&type=style&index=0&id=7dc8e1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8e1e6",
  null
  
)

export default component.exports